import {
  EmptyInput,
  FlexColumn,
  InputGroup,
  InputRow,
  ModelDateDMY,
  ModelInput,
  ModelNewNumericInput,
  ModelSelect,
  SVGInfo,
} from '@equifinance/shared';
import styled from 'styled-components';
import { useChecklistContext, ValuationType } from '../../../../../../contexts';
import { ChecklistSection } from '../../../../ChecklistPage';
import { GenericSection } from '../../../GenericSection';

const ValuationResultsWrapper = styled(FlexColumn)`${({ theme }) => `
  padding: ${theme.padding[1]} ${theme.padding[9]};;
  gap: ${theme.padding[5]};
`}`;

export default function ValuationResultsSection() {
  const { checklist } = useChecklistContext();
  const { valuation } = checklist;

  return (
    <GenericSection
      subSection={ChecklistSection.VALUATION_RESULTS}
      level={1}
    >
      <ValuationResultsWrapper>
        <SVGInfo>Please ensure that the data in Application form is up to date in line with the outputs of the Valuation report.</SVGInfo>
        <InputGroup>
          <InputRow>
            <ModelSelect
              label="Valuation Type"
              field="valuation.valuationResult.valuationType"
              options={ValuationType}
              required
              placeholder="Please select"
            />
            <ModelInput
              label="Valuers Name"
              field="valuation.valuationResult.valuersName"
              required
            />
          </InputRow>
          <InputRow>
            <ModelNewNumericInput
              label="Valuation Amount"
              field="valuation.valuationResult.valuationAmount"
              prefix="£"
              isFixedDecimal
              required
              maxCharacters={10}
            />
            <ModelDateDMY
              label="Valuation Date"
              field="valuation.valuationResult.valuationDate"
              showDay
              required
            />
          </InputRow>

          {valuation?.valuationResult?.valuationType === 'Avm' && (
            <InputRow>
              <ModelNewNumericInput
                label="Confidence"
                field="valuation.valuationResult.confidence"
                isFixedDecimal
                required
                maxCharacters={10}
              />
              <EmptyInput />
            </InputRow>
          )}
        </InputGroup>
      </ValuationResultsWrapper>
    </GenericSection>
  );
}
